import React from 'react';
import { mainMenu } from './../static-data/';

const MainMenu = () => { 
    function openMenu() {
        const mainmenu = document.querySelector('.main-menu_mobile');  
        const burger = document.querySelector('.menu__button');  
        mainmenu.classList.toggle('main-menu_mobile_visible'); 
        burger.classList.toggle('menu__button_active'); 
    } 

    return (
        <div className="header__main-menu">
            <a href="https://russian.rt.com" className="main-logo"><span className="main-logo__image" /></a> 
            <span className="menu__button" onClick={openMenu} role="presentation">
                <span className="menu__button button__line" />
                <span className="menu__button button__line" />
                <span className="menu__button button__line" />
            </span>
            <ul className="main-menu main-menu_dekstop">{
                mainMenu.map(item =>
                    (<li className="main-menu__item" key={item.name}>
                        <a href={item.url} className="main-menu__link">{item.name}</a>
                    </li>)
                )
            }</ul>
            <ul className="main-menu main-menu_mobile">{
                mainMenu.map(item =>
                    (<li className="main-menu__item" key={item.name}>
                        <a href={item.url} className="main-menu__link">{item.name}</a>
                    </li>)
                )
            }</ul>
        </div>
    );
};

export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/MainMenu.jsx